import AnalisaBarangJadiPenawaran from "./AnalisaBarangJadi"

export default AnalisaBarangJadiPenawaran